module.exports = __webpack_public_path__ + "img/08.8d421c37.png";